<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul
        data-widget="tree"
        class="sidebar-menu"
      >
        <sidebar-menu-item
          v-for="(item,index) in menuItems"
          :key="index"
          :header="item.header"
          :icon-class="item.iconClass"
          :icon-src="item.iconSrc"
          :text="item.text"
          :help-text="item.helpText"
          :help-text-hidden-on-collapse="item.helpTextHiddenOnCollapse"
          :badge="item.badge"
          :items="item.items"
          :router="item.router"
          :link="item.link"
          :target="item.target"
          :background-color="item.backgroundColor"
          :border-left-color="item.borderLeftColor"
          :open="item.open"
          :hidden="item.hidden"
          :color="item.color"
        />
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import SidebarMenuItem from '../SidebarMenuItem'
import { mapGetters, mapState } from 'vuex'
import { isModuleEnabled } from '../../helper'

/**
 * Боковое меню.
 */
export default {
  name: 'CSidebar',
  components: {
    SidebarMenuItem
  },
  computed: {
    /**
     * Элементы бокового меню.
     *
     * @returns []
     */
    menuItems () {
      return [
        {
          header: true,
          text: 'подключенные услуги'
        },
        {
          iconSrc: require('../../../img/sidebar/chart.png'),
          text: 'Продвижение сайтов',
          backgroundColor: '#d71c3a',
          open: true,
          items: [
            {
              iconClass: 'fa fa-circle-o',
              text: 'Позиции сайта',
              router: {
                name: 'Positions'
              }
            },
            {
              iconClass: 'fa fa-circle-o',
              text: 'Показатели сайта',
              router: {
                name: 'Indicators'
              }
            },
            {
              iconClass: 'fa fa-circle-o',
              text: 'Работы по продвижению',
              router: {
                name: 'Works'
              }
            },
            {
              iconClass: 'fa fa-circle-o',
              text: 'Ежемесячный отчет',
              router: {
                name: 'MonthlyReport'
              },
              badge: {
                text: this.everyMonthReports > 0 ? 'NEW' : ''
              }
            },
            {
              iconClass: 'fa fa-circle-o',
              text: 'Бухгалтерские документы',
              router: {
                name: 'Documents'
              },
              badge: {
                text: this.bookkeepingDocuments > 0 ? 'NEW' : ''
              },
              helpText: this.clientHasUnpaidDomains ? 'Не оплачены услуги продвижения' : ''
            }
          ],
          hidden: !this.isServiceConnected(this.$getConst('SERVICE_SEO'))
        },
        {
          iconSrc: require('../../../../Modules/Context/Resources/assets/images/sidebar/context-ads.svg'),
          text: 'Контекстная реклама',
          backgroundColor: '#3db613',
          open: true,
          items: [
            {
              iconClass: 'fa fa-circle-o',
              text: 'Статистика',
              router: {
                name: 'ContextStatistics'
              }
            },
            {
              iconClass: 'fa fa-circle-o',
              text: 'Сводка',
              router: {
                name: 'ContextBrief'
              }
            },
            {
              iconClass: 'fa fa-circle-o',
              text: 'Бухгалтерские документы',
              router: {
                name: 'ContextDocuments'
              }
            }
          ],
          hidden: !this.isServiceConnected(this.$getConst('SERVICE_CONTEXT'))
        },
        ...isModuleEnabled(this.$getConst('SERVICE_SERM'))
          ? [{
            iconSrc: require('../../../img/sidebar/promotion.png'),
            text: 'Управление репутацией',
            backgroundColor: '#0087f7',
            open: true,
            items: [
              // {
              //   iconClass: 'fa fa-circle-o',
              //   text: 'Медиаплан',
              //   router: {
              //     name: 'sermMediaplan'
              //   }
              // },
              // {
              //   iconClass: 'fa fa-circle-o',
              //   text: 'KPI',
              //   router: {
              //     name: 'sermKPI'
              //   }
              // },
              // {
              //   iconClass: 'fa fa-circle-o',
              //   text: 'Таймлайн проекта',
              //   router: {
              //     name: 'sermTimeline'
              //   }
              // },
              {
                iconClass: 'fa fa-circle-o',
                text: 'SERM-аналитика',
                router: {
                  name: 'sermAnalytics'
                }
              },
              {
                iconClass: 'fa fa-circle-o',
                text: 'Отзывы',
                router: {
                  name: 'sermReviews'
                }
              },
              // {
              //   iconClass: 'fa fa-circle-o',
              //   text: 'Мониторинг и коммуникация',
              //   router: {
              //     name: 'sermMonitoring'
              //   }
              // },
              {
                iconClass: 'fa fa-circle-o',
                text: 'Отчет',
                router: {
                  name: 'sermReport'
                }
              }
            ],
            hidden: !this.isServiceConnected(this.$getConst('SERVICE_SERM'))
          }]
          : [],
        {
          iconSrc: require('../../../img/sidebar/favorites.png'),
          text: 'Demis Plus: ' + this.demisPlusStatus,
          color: '#282828',
          backgroundColor: '#fdb801',
          helpTextHiddenOnCollapse: true,
          router: {
            name: 'PrivilegeProgram'
          },
          hidden: !this.isServiceConnected(this.$getConst('SERVICE_SEO'))
        },
        {
          iconSrc: require('../../../img/sidebar/discount.png'),
          text: 'Мои спецпредложения',
          router: {
            name: 'SpecialOffer'
          },
          hidden: !this.isServiceConnected(this.$getConst('SERVICE_SEO'))
        },
        {
          iconSrc: require('../../../img/sidebar/news.png'),
          text: 'Новости',
          router: {
            name: 'News'
          },
          target: '_blank'
        },
        {
          iconSrc: require('../../../img/sidebar/warning.png'),
          text: 'Статьи',
          router: {
            name: 'Articles'
          },
          target: '_blank'
        },
        {
          iconSrc: require('../../../img/sidebar/news.png'),
          text: 'Конференции и вебинары',
          router: {
            name: 'Seminars'
          },
          target: '_blank'
        },
        {
          header: true,
          text: 'все услуги'
        },
        {
          iconSrc: require('../../../img/sidebar/chart.png'),
          text: 'Продвижение сайтов',
          link: '/seo/positions'
        },
        {
          iconSrc: require('../../../img/sidebar/target.png'),
          text: 'Контекстная реклама',
          link: '/context/statistics'
        },
        {
          iconSrc: require('../../../img/sidebar/promotion.png'),
          text: 'Управление репутацией',
          link: 'https://reputation.demis.ru'
        },
        {
          iconSrc: require('../../../img/sidebar/thumbup.png'),
          text: 'SMM',
          link: 'https://smm-client.demis.ru'
        },
        // {
        //   iconSrc: require('../../../img/sidebar/monitor.png'),
        //   text: 'Юзабилити',
        //   link: '/test'
        // },
        {
          iconSrc: require('../../../img/sidebar/tech.png'),
          text: 'Техническая поддержка',
          link: 'https://help.demis.ru'
        }
      ]
    },
    /**
     * html для блока статуса.
     *
     * @returns {string|string}
     */
    demisPlusStatus () {
      if (this.clientInfoFetching) {
        return '<i class="fa fa-refresh fa-spin" />'
      }

      return this.clientInfo.loyalty_status
        ? '<span style="font-weight: bold; text-transform: uppercase">' + this.clientInfo.loyalty_status + '</span>'
        : '<span class="text-muted">нет данных</span>'
    },
    ...mapState({
      everyMonthReports: state => state.seo.existenceNewReports.everyMonthReports,
      bookkeepingDocuments: state => state.seo.existenceNewReports.bookkeepingDocuments,
      clientInfo: state => state.seo.client.info.client,
      clientInfoFetching: state => state.seo.client.info.fetching
    }),
    ...mapGetters({
      isServiceConnected: 'services/isConnected',
      clientHasUnpaidDomains: 'seo/client/unpaidDomains/hasUnpaidDomains'
    })
  }
}
</script>
